/**
 * @file
 * Attaches behaviors for the Contextual module.
 */

(function ($) {
  /**
   * Attaches outline behavior for regions associated with contextual links.
   */
  $(document).ready(function(){
      $('div.contextual-links-wrapper').each(function(){
          var $wrapper = $(this);
          var $region = $wrapper.closest('.contextual-links-region');
          var $links = $wrapper.find('ul.contextual-links');
          var $trigger = $('<a class="contextual-links-trigger" href="#" />').text('Configure').click(
              function () {
                  $links.stop(true, true).slideToggle(100);
                  $wrapper.toggleClass('contextual-links-active');
                  return false;
              }
          );
          // Attach hover behavior to trigger and ul.contextual-links.
          $trigger.add($links).hover(
              function () { $region.addClass('contextual-links-region-active'); },
              function () { $region.removeClass('contextual-links-region-active'); }
          );
          // Hide the contextual links when user clicks a link or rolls out of the .contextual-links-region.
          $region.bind('mouseleave click', function () {
              $(this)
                  .find('.contextual-links-active').removeClass('contextual-links-active')
                  .find('ul.contextual-links').hide();
          });
          $region.hover(
              function() { $trigger.addClass('contextual-links-trigger-active'); },
              function() { $trigger.removeClass('contextual-links-trigger-active'); }
          );
          // Prepend the trigger.
          $wrapper.prepend($trigger);
      });
  });
})(jQuery);
